 
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable, combineLatest, first, map, switchMap } from "rxjs";
import { RootState } from "src/app/store";
import * as FromApp from "src/app/store/app/selectors";
import { resolveApiLanguage } from "src/app/utils/resolve-language";

@Injectable({ providedIn: "root" })
export class LanguageInterceptor implements HttpInterceptor {
  private readonly store = inject<Store<RootState>>(Store);
  constructor() {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return combineLatest([
      this.store.select(FromApp.selectSessionLanguage),
      this.store.select(FromApp.selectProgram),
    ]).pipe(
      first(),
      map(([sessionLanguage, program]) => resolveApiLanguage(sessionLanguage ?? this.resolveNavigatorLanguage(), program)),
      switchMap(language => {
        req = req.clone({ setHeaders: { "X-APP-LANGUAGE": language } });
        return next.handle(req);
      }),
    );
  }

  private resolveNavigatorLanguage(): string {
    try {
      return new Intl.Locale(navigator.language).language;
    } catch {
      return "";
    }
  }
}
